import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const AmenagementPaysager = () => {
  // Initialiser Google Ads
  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'AW-16912204930');
    }
  }, []);

  // Slider pour les réalisations
  const [currentSlide, setCurrentSlide] = useState(0);
  
  // Liste des images de réalisations (vous pouvez ajouter plus d'images ici)
  const realisations = [
    '/paysager/paysager.webp',
    '/paysager/paysager2.jpg',
    '/paysager/paysager3.jpeg',
    '/paysager/paysager4.webp',
    '/paysager/paysager5.jpg',
    // Ajoutez d'autres images ici quand vous les ajouterez au dossier
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % realisations.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + realisations.length) % realisations.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  // Auto-play du slider
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % realisations.length);
    }, 5000); // Change d'image toutes les 5 secondes

    return () => clearInterval(interval);
  }, [realisations.length]);
  const features = [
    "Conception sur mesure : Design adapté à vos goûts et à votre espace.",
    "Plantation professionnelle : Choix des végétaux adaptés au sol et au climat.",
    "Aménagement durable : Solutions pérennes pour un jardin qui dure.",
    "Entretien facilité : Sélection de plantes nécessitant peu d'entretien.",
    "Esthétique soignée : Harmonie des couleurs et des formes.",
    "Valorisation de votre espace : Augmente la valeur de votre propriété."
  ];

  return (
    <div className="page-container">
      <div className="page-content">
        <div className="section-header">
          <div className="section-badge">Aménagement paysager</div>
          <h1 className="page-title">Aménagement paysager</h1>
        </div>

        {/* Main Image Section - Two Images Side by Side */}
        <section className="modern-section" style={{padding: '0 0 clamp(2rem, 4vw, 3rem) 0'}}>
          <div style={{
            display: 'flex',
            gap: '1rem',
            width: '100%',
            maxWidth: '1200px',
            margin: '0 auto',
            padding: '0 clamp(1rem, 3vw, 1.8rem)'
          }}>
            {/* Left Image */}
            <div style={{
              flex: '1',
              borderRadius: '16px',
              overflow: 'hidden',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
              aspectRatio: '16/9',
              position: 'relative'
            }}>
              <img 
                src="/paysager/paysager.webp" 
                alt="Aménagement paysager" 
                loading="lazy"
                style={{
                  width: '100%',
                  height: '100%',
                  display: 'block',
                  objectFit: 'cover',
                  borderRadius: '16px'
                }}
              />
            </div>
            
            {/* Right Image */}
            <div style={{
              flex: '1',
              borderRadius: '16px',
              overflow: 'hidden',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
              aspectRatio: '16/9',
              position: 'relative'
            }}>
              <img 
                src="/paysager/paysager2.jpg" 
                alt="Jardin aménagé" 
                loading="lazy"
                style={{
                  width: '100%',
                  height: '100%',
                  display: 'block',
                  objectFit: 'cover',
                  borderRadius: '16px'
                }}
              />
            </div>
          </div>
        </section>

        <div className="modern-section" style={{paddingTop: '2rem'}}>
          <div className="section-container">
            <div className="modern-card" style={{maxWidth: '900px', margin: '0 auto'}}>
              <p className="page-text" style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', marginBottom: '2rem'}}>
                L'aménagement paysager transforme votre espace extérieur en un véritable havre de paix. Notre équipe de paysagistes professionnels conçoit et réalise des jardins sur mesure, adaptés à vos besoins et à votre environnement. De la conception à la plantation, nous créons des espaces verts harmonieux, durables et faciles à entretenir. Valorisez votre propriété avec un aménagement paysager de qualité !
              </p>

              <h3 className="section-title" style={{fontSize: 'clamp(1.5rem, 4vw, 2rem)', marginTop: '3rem', marginBottom: '2rem'}}>
                Nos caractéristiques :
              </h3>

              <ul style={{listStyle: 'none', padding: 0, marginTop: '2rem'}}>
                {features.map((feature, index) => (
                  <li key={index} style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '1rem',
                    marginBottom: '1.5rem',
                    padding: '1rem',
                    background: 'var(--color-beige-light)',
                    borderRadius: '12px',
                    transition: 'var(--transition)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = 'var(--color-accent-light)';
                    e.currentTarget.style.transform = 'translateX(5px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'var(--color-beige-light)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}>
                    <svg width="24" height="24" viewBox="0 0 512 512" fill="currentColor" style={{
                      color: 'var(--color-primary)',
                      flexShrink: 0,
                      marginTop: '2px'
                    }}>
                      <path d="M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm-28.9 143.6l75.5 72.4H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h182.6l-75.5 72.4c-9.7 9.3-9.9 24.8-.4 34.3l11 10.9c9.4 9.4 24.6 9.4 33.9 0L404.3 273c9.4-9.4 9.4-24.6 0-33.9L271.6 106.3c-9.4-9.4-24.6-9.4-33.9 0l-11 10.9c-9.5 9.6-9.3 25.1.4 34.4z"></path>
                    </svg>
                    <span style={{
                      color: 'var(--color-dark)',
                      fontSize: 'clamp(0.95rem, 2.5vw, 1.125rem)',
                      lineHeight: '1.6',
                      flex: 1
                    }}>{feature}</span>
                  </li>
                ))}
              </ul>

              <div style={{marginTop: '3rem', textAlign: 'center'}}>
                <Link to="/contact" className="modern-button">
                  <span>Demander un devis</span>
                  <svg width="20" height="20" viewBox="0 0 512 512" fill="currentColor">
                    <path d="M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm-28.9 143.6l75.5 72.4H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h182.6l-75.5 72.4c-9.7 9.3-9.9 24.8-.4 34.3l11 10.9c9.4 9.4 24.6 9.4 33.9 0L404.3 273c9.4-9.4 9.4-24.6 0-33.9L271.6 106.3c-9.4-9.4-24.6-9.4-33.9 0l-11 10.9c-9.5 9.6-9.3 25.1.4 34.4z"></path>
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Section Nos Réalisations - Slider */}
        <section className="modern-section" style={{paddingTop: '4rem', paddingBottom: '4rem'}}>
          <div className="section-container">
            <div style={{textAlign: 'center', marginBottom: '3rem'}}>
              <h2 className="section-title" style={{fontSize: 'clamp(2rem, 5vw, 2.5rem)', marginBottom: '1rem'}}>
                Nos réalisations
              </h2>
              <p style={{fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', color: 'var(--color-text)', maxWidth: '600px', margin: '0 auto'}}>
                Découvrez quelques-unes de nos réalisations d'aménagement paysager
              </p>
            </div>

            <div style={{
              position: 'relative',
              maxWidth: '1200px',
              margin: '0 auto',
              padding: '0 clamp(1rem, 3vw, 1.8rem)'
            }}>
              {/* Slider Container */}
              <div style={{
                position: 'relative',
                width: '100%',
                borderRadius: '16px',
                overflow: 'hidden',
                boxShadow: '0 8px 30px rgba(0, 0, 0, 0.15)',
                aspectRatio: '16/9',
                backgroundColor: '#f5f5f5'
              }}>
                {/* Images */}
                {realisations.map((image, index) => (
                  <div
                    key={index}
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      opacity: index === currentSlide ? 1 : 0,
                      transition: 'opacity 0.6s ease-in-out',
                      zIndex: index === currentSlide ? 1 : 0
                    }}
                  >
                    <img
                      src={image}
                      alt={`Réalisation ${index + 1}`}
                      loading={index === currentSlide ? 'eager' : 'lazy'}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        display: 'block'
                      }}
                    />
                  </div>
                ))}

                {/* Navigation Buttons */}
                {realisations.length > 1 && (
                  <>
                    <button
                      onClick={prevSlide}
                      aria-label="Image précédente"
                      style={{
                        position: 'absolute',
                        left: '1rem',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        zIndex: 10,
                        background: 'rgba(255, 255, 255, 0.9)',
                        border: 'none',
                        borderRadius: '50%',
                        width: '48px',
                        height: '48px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = 'rgba(255, 255, 255, 1)';
                        e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = 'rgba(255, 255, 255, 0.9)';
                        e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
                      }}
                    >
                      <svg width="24" height="24" viewBox="0 0 512 512" fill="currentColor" style={{color: 'var(--color-primary)'}}>
                        <path d="M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm28.9-143.6l-75.5-72.4H392c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24H209.4l75.5-72.4c9.7-9.3 9.9-24.8.4-34.3l-11-10.9c-9.4-9.4-24.6-9.4-33.9 0L107.7 239c-9.4 9.4-9.4 24.6 0 33.9L240.1 406.3c9.4 9.4 24.6 9.4 33.9 0l11-10.9c9.5-9.6 9.3-25.1-.4-34.4z"></path>
                      </svg>
                    </button>

                    <button
                      onClick={nextSlide}
                      aria-label="Image suivante"
                      style={{
                        position: 'absolute',
                        right: '1rem',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        zIndex: 10,
                        background: 'rgba(255, 255, 255, 0.9)',
                        border: 'none',
                        borderRadius: '50%',
                        width: '48px',
                        height: '48px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = 'rgba(255, 255, 255, 1)';
                        e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = 'rgba(255, 255, 255, 0.9)';
                        e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
                      }}
                    >
                      <svg width="24" height="24" viewBox="0 0 512 512" fill="currentColor" style={{color: 'var(--color-primary)'}}>
                        <path d="M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm-28.9 143.6l75.5 72.4H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h182.6l-75.5 72.4c-9.7 9.3-9.9 24.8-.4 34.3l11 10.9c9.4 9.4 24.6 9.4 33.9 0L404.3 273c9.4-9.4 9.4-24.6 0-33.9L271.6 106.3c-9.4-9.4-24.6-9.4-33.9 0l-11 10.9c-9.5 9.6-9.3 25.1.4 34.4z"></path>
                      </svg>
                    </button>
                  </>
                )}

                {/* Dots Indicators */}
                {realisations.length > 1 && (
                  <div style={{
                    position: 'absolute',
                    bottom: '1.5rem',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    zIndex: 10,
                    display: 'flex',
                    gap: '0.5rem',
                    alignItems: 'center'
                  }}>
                    {realisations.map((_, index) => (
                      <button
                        key={index}
                        onClick={() => goToSlide(index)}
                        aria-label={`Aller à l'image ${index + 1}`}
                        style={{
                          width: index === currentSlide ? '24px' : '12px',
                          height: '12px',
                          borderRadius: '6px',
                          border: 'none',
                          background: index === currentSlide ? 'var(--color-primary)' : 'rgba(255, 255, 255, 0.6)',
                          cursor: 'pointer',
                          transition: 'all 0.3s ease',
                          padding: 0
                        }}
                        onMouseEnter={(e) => {
                          if (index !== currentSlide) {
                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.9)';
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (index !== currentSlide) {
                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.6)';
                          }
                        }}
                      />
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AmenagementPaysager;
